<template>
  <div class="language-dropdown">
    <p id="lang-label" class="sr-only" v-html="'Select a language. Language selected: ' + $t('langName')"></p>
    <svg aria-hidden="true" class="globe-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"/></svg>
    <button  @keydown.esc="showDropdown = false" @keydown="!isSafari ? toggleLang($event) : null" type="button" aria-labelledby="lang-label" :aria-expanded="showDropdown ? 'true' : 'false'" ref="lang-btn" class="lang-btn" @click="dropDownTgl">{{ $t('langName') }}</button>
    <svg aria-hidden="true" class="down-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"/></svg>
    <ul :tabindex="isFirefox ? '-1' : null" aria-describedby="desc" v-show="showDropdown" aria-labelledby="language-picker" ref="langList" class="lang-btn-content">
      <li
          :id="`option-${i}`"
          :data-id="idx"
          :data-code="i"
          @keydown.esc="closeAndFocus"
          @click="updateLang(i, idx)"
          @keydown="keyHandler($event, i, idx)"
          :aria-selected="$i18n.locale === i ? 'true' : 'false'"
          :class="{'is-active' : $i18n.locale === i}"
          :key="`Lang${i}`"
          tabindex="0"
          v-for="(trans, i, idx) in $i18n.messages">
        {{trans['langName']}}
        <svg v-if="$i18n.locale === i" aria-hidden="true" class="check-icon" :class="['selected-lang']" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>
      </li>
    </ul>
  </div>
</template>

<script>
import { store } from '../../js/reactiveStates.js'

export default {
  name: 'language-dropdown',
  computed: {
    isSafari: function() {
      return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
          navigator.userAgent &&
          navigator.userAgent.indexOf('CriOS') === -1 &&
          navigator.userAgent.indexOf('FxiOS') === -1
    },
    isFirefox: function() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
  },
  data () {
    return {
      store,
      showDropdown: false,
      langs: [
        {
            'name' : 'English',
            'code' :'en'
        },
        {
          'name' : 'Français',
          'code' : 'fr'
        }
      ]
    }
  },
  mounted() {
    store.chosenLanguage = this.getInitialLang();
  },
  methods: {
    keyHandler(event, i, idx) {
      if (event.keyCode === 32 || event.keyCode === 13) {
        this.updateLang(i, idx)
      }
    },
    toggleLang(event) {
      if (event.keyCode === 32 || event.keyCode === 13) {
        this.showDropdown = !this.showDropdown
      }
      if (this.showDropdown && event.keyCode === 9) {
        setTimeout(() => {
          this.$refs.langList.children[0].focus()
        }, 500)
      }
    },
    //Initially set the language of the drowndown
    getInitialLang() {
      let uLang = store.chosenLanguage;
      if(typeof store.chosenLanguage != 'undefined' && Object.entries(this.$i18n.messages).some(row => row[0] == store.chosenLanguage)) {
        uLang = store.chosenLanguage;
      }
      // else if(typeof store.chosenLanguage == 'undefined' || store.chosenLanguage.length < 2) {
      //   uLang = navigator.languages ? navigator.languages[0] : (navigator.language);
      //   if(uLang.length > 2)
      //   {
      //     uLang = uLang.substr(0,2);
      //   }
      // }

      if(uLang.length < 2)
      {
        uLang = 'en';
      }

      return uLang;
    },
    updateLang(code) {
      this.$i18n.locale = store.chosenLanguage = code
      store.manualLanguageSelect = true;
      this.closeAndFocus()
    },
    closeAndFocus() {
      // If user presses *ESC* key while the dropdown is open, the dropdown will close and the focus will be moved to the button trigger
      this.showDropdown = false
      setTimeout(() => {
        this.$refs["lang-btn"].focus()
      })
    },
    dropDownTgl() {
      this.showDropdown = !this.showDropdown
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 0;
}

.is-active {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 5px;
}
</style>

